//create http reducer function
export const createHttpReducer = (name, intialState = {fetching: false, data: null, error: false}) => {
    return (state = intialState, action) => {
        if( action.type === (name + '_FETCHING') ){
            return {...state, fetching: true, data: null, error: false}
        }
        if( action.type === (name + '_FULFILLED') ){
            return {...state, fetching: false, data: action.payload}
        }
        if( action.type === (name + '_REJECTED') ){
            return {...state, fetching: false, error: action.payload}
        }
        if( action.type === (name + '_CLEAR') ){
            return {...state, ...intialState}
        }
        return state;
    }
}

export const createListReducer = (name, intialState = {fetching: false, data: [], error: false, nextFetching: false, nextError: false, next: null}) => {
    return (state = intialState, action) => {
        switch(action.type){
            case name + '_FETCHING':
                return {...state, ...intialState, fetching: true}
            case name + '_FULFILLED':
                return { ...state,
                    fetching: false,
                    data: action.payload.results,
                    next: action.payload.next
                }
            case name + '_REJECTED':
                return {...state, fetching: false, error: action.payload}
            case name + '_NEXT_FETCHING':
                return {...state, nextFetching: true, nextError: false}
            case name + '_NEXT_FULFILLED':
                return {...state, 
                    nextFetching: false,
                    next: action.payload.next,
                    data: [...state.data, ...action.payload.results]
                }
            case name + '_NEXT_REJECTED':
                return {...state, nextFetching: false, nextError: true}
            case name + '_CLEAR':
                return {...state, ...intialState}
            default: 
                return state;
        }
    }
}